import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dccc76d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "title"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "自定义书签", -1))
const _hoisted_3 = { class: "tab" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "tab-cont" }
const _hoisted_6 = {
  key: 0,
  class: "online-icons"
}
const _hoisted_7 = { class: "loading-tip" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "color-cont"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "btn-box" }

import { ref, onMounted, watch, reactive, nextTick } from 'vue';
import { Close } from '@rafter/icon';
import {
  RaInput,
  RaColorPicker,
  RaButton,
  RaEmpty,
  RaMessage,
  RaSelect,
  RaOption,
} from '@rafter/pc';
import { addBookmark, putBookmark, getFaviconByUrl } from '@/api/baseApi';
import { bookmarks } from '@/store/bookmarks';
interface Tab {
  value: string;
  label: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomMark',
  props: {
  type: {
    type: String,
    default: '',
  },
  categorie: {
    type: Object,
    default: () => {},
  },
  detail: {
    type: Object,
    default: null,
  },
  saveBookmark: {
    type: Function,
    default: null,
  },
  categoriesList: {
    type: Array,
    default: () => [],
  },
},
  emits: ['handleClose', 'getMarks', ''],
  setup(__props, { emit: emits }) {

const props = __props;



const name = ref('');
const staticSty = ref(false);
const category_uuid = ref('');
const colorList = ref([
  { backgroundColor: 'rgb(244, 171, 18)' },
  { backgroundColor: 'rgb(74, 197, 92)' },
  { backgroundColor: 'rgb(67, 133, 241)' },
  { backgroundColor: 'rgb(56, 100, 255)' },
  { backgroundColor: 'rgb(118, 33, 249)' },
  { backgroundColor: 'rgb(224, 78, 78)' },
  { backgroundColor: 'rgb(253, 90, 90)' },
  { backgroundColor: 'rgb(183, 163, 150)' },
  { backgroundColor: 'rgb(171, 131, 131)' },
  { backgroundColor: 'rgb(182, 150, 135)' },
  { backgroundColor: 'rgb(109, 131, 95)' },
  { backgroundColor: 'rgb(125, 171, 136)' },
  { backgroundColor: 'rgb(158, 172, 175)' },
  { backgroundColor: 'rgb(103, 124, 170)' },
  { backgroundColor: 'rgb(150, 150, 150)' },
  { backgroundColor: 'rgb(58, 58, 60)' },
  { backgroundColor: 'rgb(28, 28, 30)' },
]);
const urlValue = ref('');
const iconType = ref<Array<Tab>>([
  { label: '在线图标', value: 'online' },
  { label: '自定义图标', value: 'usersetting' },
]);
const checkedType = ref<Tab>({ label: '在线图标', value: 'online' });
const color = ref();
const icon = ref('');
const iconIndex = ref<number>();
const oneLineIcons = ref<Array<string>>([]);
const data = reactive({
  isRequestIcon: false,
});
/**
 * @name:
 * @description: 切换tab
 * @msg:
 * @return {*}
 */
const handleTabs = (item: Tab) => {
  checkedType.value = item;
};
const handleColor = (item: { backgroundColor: string }) => {
  color.value = item.backgroundColor;
};
const addComp = () => {
  if (!urlValue.value)
    return RaMessage({ type: 'error', message: '请输入网址' });
  if (!name.value) return RaMessage({ type: 'error', message: '请输入名称' });
  if (!icon.value && checkedType.value.value === 'online')
    return RaMessage({ type: 'error', message: '请选择图标' });
  if (!color.value && checkedType.value.value === 'usersetting')
    return RaMessage({ type: 'error', message: '请选择图标颜色' });
  if (props.saveBookmark) {
    if (!category_uuid.value) {
      return RaMessage({ type: 'error', message: '请选择分类' });
    }

    props.saveBookmark(
      {
        name: name.value,
        category_uuid: category_uuid.value,
        color: color.value,
        icon: icon.value,
        url: urlValue.value,
      },
      getMarksList
    );
    return;
  }
  if (props.detail) {
    putBookmark(props.detail?.uuid, {
      ...props.detail,
      type: 1,
      name: name.value,
      url: fixUrlProtocol(urlValue.value),
      color: color.value,
      category_uuid: bookmarks.getActive()?.uuid,
      icon: checkedType.value.value === 'online' ? icon.value : '',
    }).then((res) => {
      RaMessage({
        type: 'success',
        message: '修改成功',
      });
      bookmarks.changeOnInActive(res);
      emits('getMarks');
      emits('handleClose');
    });
  } else {
    window['_paq'].push(['trackEvent', '书签', '手动新增', urlValue.value, 1]);

    addBookmark({
      type: 1,
      name: name.value,
      url: fixUrlProtocol(urlValue.value),
      color: color.value,
      category_uuid: bookmarks.getActive()?.uuid,
      icon: checkedType.value.value === 'online' ? icon.value : '',
      order: bookmarks.getActive()?.bookmarks.length + 1,
    })
      .then((res) => {
        RaMessage({
          type: 'success',
          message: '添加成功',
        });

        bookmarks.addOneToActive(res);
        emits('handleClose');
      })
      .catch((err) => {
        RaMessage({
          type: 'error',
          message: '接口出错',
        });
      });
  }
};
const handleClose = () => {
  emits('handleClose');
};
const getMarksList = () => {
  emits('getMarks');
};
watch(
  () => [props.detail],
  () => {
    if (props.detail) {
      urlValue.value = props.detail.url;
      name.value = props.detail.name;
      color.value = props.detail.color;
      icon.value = props.detail.icon;
      category_uuid.value = props.detail.category_uuid;
    }
  }
);
const inputRef1 = ref();
onMounted(() => {
  if (props.detail) {
    urlValue.value = props.detail.url;
    name.value = props.detail.name;
    color.value = props.detail.color;
    icon.value = props.detail.icon;
    category_uuid.value = props.detail.category_uuid;
    if (props.detail.icon) {
      checkedType.value = { label: '在线图标', value: 'online' };
    } else {
      checkedType.value = { label: '自定义图标', value: 'usersetting' };
    }
    getWebSiteIcon(true);
  }
  nextTick(() => {
    const textarea = document.getElementsByClassName('ra-textarea')[0];
    console.log(textarea);
    textarea.focus();
  });
});

/**
 * @description: 获取站点icon
 * @return {*}
 */
const getWebSiteIcon = (hasIcon: boolean = false) => {
  const domain = fixUrlProtocol(urlValue.value);
  try {
    const url = new URL(domain);
    oneLineIcons.value = [];
    if (hasIcon && icon.value) {
      oneLineIcons.value.push(icon.value);
    }
    data.isRequestIcon = true;
    getFaviconByUrl(`${url.protocol}//${url.host}`)
      .then((res) => {
        data.isRequestIcon = false;
        if (res.data.code === 200) {
          oneLineIcons.value = oneLineIcons.value.concat(res.data.data);
        }
      })
      .catch(() => {
        data.isRequestIcon = false;
      });
  } catch {}
};

const fixUrlProtocol = (url: string): string => {
  if (!/^https?:\/\//i.test(url)) {
    url = 'https://' + url;
  }
  return url;
};

/**
 * @description: 设置icon
 * @return {*}
 */
const handleIcon = (index) => {
  iconIndex.value = index;
  icon.value = oneLineIcons.value[index];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ custom: true, contentCls: props.type === 'content' })
  }, [
    (props.type !== 'content')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_unref(Close))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(RaInput), {
      type: "textarea",
      ref_key: "inputRef1",
      ref: inputRef1,
      modelValue: urlValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((urlValue).value = $event)),
      placeholder: "请输入网址",
      resize: "none",
      onInput: getWebSiteIcon
    }, null, 8, ["modelValue"]),
    _createVNode(_unref(RaInput), {
      placeholder: "名称",
      class: "name",
      modelValue: name.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((name).value = $event))
    }, null, 8, ["modelValue"]),
    (props.categoriesList.length)
      ? (_openBlock(), _createBlock(_unref(RaSelect), {
          key: 1,
          modelValue: category_uuid.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((category_uuid).value = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.categoriesList, (item, index) => {
              return (_openBlock(), _createBlock(_unref(RaOption), {
                key: index,
                value: item.uuid,
                label: item.name
              }, null, 8, ["value", "label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(iconType.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.value,
          onClick: ($event: any) => (handleTabs(item)),
          class: _normalizeClass({ item: true, active: checkedType.value.value === item.value })
        }, _toDisplayString(item.label), 11, _hoisted_4))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      (checkedType.value.value === 'online')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _withDirectives(_createElementVNode("div", _hoisted_7, " 正在获取在线图标，请稍等... ", 512), [
              [_vShow, data.isRequestIcon]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(oneLineIcons.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass({ item: true, active: item === icon.value }),
                key: index,
                onClick: ($event: any) => (handleIcon(index))
              }, [
                _createElementVNode("img", { src: item }, null, 8, _hoisted_9)
              ], 10, _hoisted_8))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colorList.value, (colorItem) => {
              return (_openBlock(), _createElementBlock("div", {
                key: colorItem.backgroundColor,
                class: "color-item",
                style: _normalizeStyle({ background: colorItem.backgroundColor }),
                onClick: ($event: any) => (handleColor(colorItem))
              }, null, 12, _hoisted_11))
            }), 128)),
            _createVNode(_unref(RaColorPicker), {
              modelValue: color.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((color).value = $event))
            }, null, 8, ["modelValue"])
          ])),
      (checkedType.value.value !== 'online')
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "mark-icon",
            style: _normalizeStyle({ background: color.value })
          }, [
            _createVNode(_unref(RaInput), {
              modelValue: name.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((name).value = $event)),
              placeholder: "点击输入",
              class: _normalizeClass({ staticSty: staticSty.value }),
              onFocus: _cache[5] || (_cache[5] = ($event: any) => (staticSty.value = true)),
              onBlur: _cache[6] || (_cache[6] = ($event: any) => (staticSty.value = false))
            }, null, 8, ["modelValue", "class"])
          ], 4))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", {
          class: _normalizeClass({
            'btn-cont': true,
            fillWidth: !!props.categoriesList.length,
          })
        }, [
          (!props.categoriesList.length)
            ? (_openBlock(), _createBlock(_unref(RaButton), {
                key: 0,
                class: "btn-style",
                status: "tertiary",
                onClick: handleClose
              }, {
                default: _withCtx(() => [
                  _createTextVNode("取消")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_unref(RaButton), {
            class: "btn-style",
            onClick: addComp
          }, {
            default: _withCtx(() => [
              _createTextVNode("保存")
            ]),
            _: 1
          })
        ], 2)
      ])
    ])
  ], 2))
}
}

})